export const encodeToUrlParams = (obj) => {
    if (obj instanceof String) {
      return obj;
    }
    const queryString = Object.keys(obj)
      .reduce((a, k) => {
        if (Array.isArray(obj[k]) && obj[k].length > 0 ) {
          obj[k] = obj[k].map(encodeURIComponent)
          a.push(`${k}[]=${obj[k].join('&'+k+'[]=')}`);
        } else {
          a.push(`${k}=${encodeURIComponent(obj[k])}`);
        }
        return a;
      }, []).join('&');
    return `${queryString}`;
};

export const msToTime = (duration) => {
  let seconds = Math.floor((duration / 1000) % 60);
  let minutes = Math.floor((duration / (1000 * 60)) % 60);
  let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;
  return hours === "00"
    ? `${minutes}:${seconds}`
    : `${hours}:${minutes}:${seconds}`;
};

export const getFileNameFromContentDispositionHeader = (header) => {
  if (!header) {
    return null;
  }
  // Split the header by ';' to get an array of key-value pairs
  const keyValuePairs = header.split(';');

  // Iterate over the array and split each element by '='
  for (const keyValuePair of keyValuePairs) {
    const [key, value] = keyValuePair.split('=');

    // Check if the key is 'filename', and if it is, then the value is the file name
    if (key.trim().toLowerCase() === 'filename') {
      return value.replace(/"/g, '');
    }
  }

  return null;
}

export function bytesToKB(bytes, decimals = 0) {
  if (!bytes) {
      return 0;
  }
  return parseFloat((bytes / 1024 ** 1).toFixed(decimals));
}